export const CONTACT = {
  email: "aci@instruments.nz",
  address: "13 Morepork Lane, Ngāruawāhia, Waikato",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=13+Morepork+Lane,+Ngaruawahia,+New+Zealand",
  logoUrl: "/aci-logo.png",
};

export const SERVICES = [
  {
    key: "pressure",
    name: "Pressure",
    blurb:
      "Pressure gauges, transducers and transmitters calibrated against traceable pressure standards.",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/82a019f25d9c8a51_image.webp",
    imageAlt: "ACI technicians calibrating a pressure transmitter on a stainless-steel process vessel with a documenting calibrator",
    tag: "PRESSURE",
  },
  {
    key: "temperature",
    name: "Temperature",
    blurb:
      "Thermometers, probes, RTDs, thermocouples and temperature transmitters.",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/42853187d251b5c9_image.png",
    imageAlt: "Technician calibrating a temperature probe in a dry-block calibrator",
    tag: "TEMPERATURE",
  },
  {
    key: "flow",
    name: "Flow meters",
    blurb:
      "Blue Tick accredited flow meter verification and calibration for water, process and utility measurement.",
    image: "https://images.pexels.com/photos/4494656/pexels-photo-4494656.jpeg?auto=compress&cs=tinysrgb&w=1200",
    imageAlt: "Bank of water flow meters connected by pipework",
    tag: "FLOW",
  },
  {
    key: "electrical",
    name: "Electrical",
    blurb:
      "Fluke multimeters, clamp meters, process calibrators and electrical test instruments.",
    image: "https://images.pexels.com/photos/14319099/pexels-photo-14319099.jpeg?auto=compress&cs=tinysrgb&w=1200",
    imageAlt: "Technician using a Fluke multimeter on an industrial control panel",
    tag: "ELECTRICAL // FLUKE",
  },
  {
    key: "conductivity",
    name: "Conductivity",
    blurb:
      "Conductivity meters and cells for water, dairy and process applications.",
    thumb: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/9fa9e921029c0389_image.png",
    thumbAlt: "Rosemount Xi liquid analyser transmitter",
  },
  {
    key: "ph",
    name: "pH",
    blurb: "pH meters and electrodes calibrated with traceable buffer solutions.",
    thumb: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/307766993070bff6_image.png",
    thumbAlt: "Endress+Hauser Liquiline pH transmitter",
  },
  {
    key: "humidity",
    name: "Relative humidity",
    blurb: "Hygrometers, humidity probes and environmental data loggers.",
    thumb: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/c32cf3bdbeea58d8_image.png",
    thumbAlt: "Vaisala humidity and temperature indicator",
  },
  {
    key: "level",
    name: "Level",
    blurb: "Level transmitters, gauges and switches for tanks and process vessels.",
    thumb: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/35239e47bc5183dd_image.png",
    thumbAlt: "Level instruments: magnetic level gauge, float, radar and submersible level transmitters",
  },
  {
    key: "onsite",
    name: "On-site calibration",
    blurb:
      "We come to you — calibration at your plant or site across Auckland and Waikato.",
    thumb: "https://images.unsplash.com/photo-1585366958113-e28e8e580d3a?w=600&q=80",
    thumbAlt: "Precision touch probe measuring a steel ring gauge",
    thumbPosition: "25% 55%",
  },
  {
    key: "other",
    name: "Other instrumentation",
    blurb:
      "Control valves, positioners and more — contact us with the make, model and range and we will confirm scope.",
    thumb: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/f7b520d6aae2bead_image.png",
    thumbAlt: "Pneumatic control valve with digital valve positioner",
  },
];

export const INDUSTRIES = [
  { key: "food", name: "Food, beverage and dairy" },
  { key: "councils", name: "Councils and local government" },
  { key: "farmers", name: "Farmers and agriculture" },
  { key: "pharma", name: "Pharmaceuticals" },
  { key: "water", name: "Water" },
  { key: "petrochemical", name: "Petrochemical" },
  { key: "power", name: "Power generation", video: "windTurbine" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1513827574967-e763dd0bc329?w=1600&q=80",
  technician: "https://images.pexels.com/photos/34938446/pexels-photo-34938446.jpeg?auto=compress&cs=tinysrgb&w=1200",
  food: "https://images.pexels.com/photos/33514501/pexels-photo-33514501.jpeg?auto=compress&cs=tinysrgb&w=1200",
  councils: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1200&q=80",
  farmers: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80",
  pharma: "https://images.unsplash.com/photo-1513828170880-00eeeac21306?w=1200&q=80",
  water: "https://customer-assets-4nw71qhi.emergentagent.net/job_instrument-cal-nz/artifacts/1c48225860bee283_image.png",
  petrochemical: "https://images.unsplash.com/photo-1694532438941-06bb0d95dae5?w=1200&q=80",
  power: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1200&q=80",
};

/** Slow-motion looped background clips (Mixkit free licence, muted, 720p).
 *  MP4 served from Mixkit CDN; self-hosted WebM fallback for browsers without H.264. */
const clip = (id, name) => ({
  sources: [
    { src: `https://assets.mixkit.co/videos/${id}/${id}-720.mp4`, type: "video/mp4" },
    { src: `/video/${name}.webm`, type: "video/webm" },
  ],
  poster: `https://assets.mixkit.co/videos/${id}/${id}-thumb-360-0.jpg`,
});

export const VIDEOS = {
  heroWater: clip(51665, "hero-water"),
  labWork: clip(17675, "lab-work"),
  riverLight: clip(51597, "river-light"),
  windTurbine: clip(10190, "wind-turbine"),
};

export const INSTRUMENT_TYPES = [
  "Pressure",
  "Temperature",
  "Flow meter",
  "Electrical",
  "Conductivity",
  "pH",
  "Relative humidity",
  "Level",
  "On-site calibration",
  "Other / not sure",
];
